import { createContext, useContext, useMemo, useState } from "react";

const HeaderActions = createContext(null);

/** A persistent layout can put controls in the current page's header without
 * remounting its listeners, sheets or the page's booking/payment forms. */
export function PageHeaderActionsProvider({ children }) {
  const [target, setTarget] = useState(null);
  const value = useMemo(() => ({ target, setTarget }), [target]);
  return <HeaderActions.Provider value={value}>{children}</HeaderActions.Provider>;
}

export const usePageHeaderActions = () => useContext(HeaderActions);
